module.exports = __webpack_public_path__ + "img/Delete - White - Selected.72ac3a0e.png";